import { render, staticRenderFns } from "./ProductDetailAboveProductDetailImagesHook.vue?vue&type=template&id=35660e58&"
import script from "./ProductDetailAboveProductDetailImagesHook.js?vue&type=script&lang=js&"
export * from "./ProductDetailAboveProductDetailImagesHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports